import React, { memo } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { boltColor, picoBoltColor, alumBifoldBoltColor } from "./defaults";
import { RowLayout } from "../../util/accordianStyles";
import useShootboltSelector from "./useShootboltSelector";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";

function ShootBoltAccordian() {
  const { variant, checkMark, handleClick, stilesAndRails, isAlumBifold } =
    useShootboltSelector();
  const { readOnly } = useIsReadOnlyContextProviderContext();

  const colorOptions = isAlumBifold
    ? alumBifoldBoltColor
    : stilesAndRails?.includes("Pico")
      ? picoBoltColor
      : boltColor;

  return (
    <ReusableAccordian
      accordionName="shootBolt"
      heading="Shoot-Bolt Handle Color"
      secondaryHeading="Select desired shoot bolt color"
    >
      <RowLayout>
        {colorOptions.map((state) => (
          <div key={state.id} onClick={() => readOnly ? null : handleClick(state.label)}>
            <Choices
              label={state.label}
              variant={variant(state.label)}
              checkMark={checkMark(state.label)}
              wide={true}
              disabled={readOnly}
            />
          </div>
        ))}
      </RowLayout>
    </ReusableAccordian>
  );
}

export default memo(ShootBoltAccordian);
